import { Box } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

const A11yTabPanel: FC<PropsWithChildren<A11yTabPanelProps>> = (props) => {
  const { children, value, index, prefix, disablePadding, ...other } = props;

  return (
    <Box
      role='tabpanel'
      component={'div'}
      hidden={value !== index}
      id={`${prefix}-tabpanel-${index}`}
      aria-labelledby={`${prefix}-tab-${index}`}
      {...other}>
      {value === index && <Box padding={disablePadding ?? false ? 0 : 2}>{children}</Box>}
    </Box>
  );
};

export interface A11yTabPanelProps {
  index: number;
  value: number;
  prefix: string;
  disablePadding?: boolean;
}

export default A11yTabPanel;
